import React from 'react';
import { Route } from 'react-router-dom';
import { lazyWithRetry } from './lazyWithRetry';
import AuthorizedLayout from '../layout/AuthorizedLayout';

const Home = lazyWithRetry(() => import("../pages/home/Home"));
const SearchResults = lazyWithRetry(() => import("../pages/SearchResults"));
const SingleEvent = lazyWithRetry(() => import("../pages/single-event/SingleEvent"));
const Checkout = lazyWithRetry(() => import("../pages/Checkout"));
const DealDetail = lazyWithRetry(() => import("../components/DealDetail"));
const Lifestyle = lazyWithRetry(() => import("../pages/lifestyle/Lifestyle"));
const DealRequests = lazyWithRetry(() => import("../pages/DealRequests"));
const SpinWinPage = lazyWithRetry(() => import("../pages/home/SpinWinPage"));
const AppOnlyFeature = lazyWithRetry(() => import("../pages/AppOnlyFeature"));

const Profile = lazyWithRetry(() => import("../pages/Profile"));
const ProfileInfo = lazyWithRetry(() => import("../pages/ProfileInfo"));
const ProfileAlerts = lazyWithRetry(() => import("../pages/ProfileAlerts"));
const ProfilePrizes = lazyWithRetry(() => import("../pages/ProfilePrizes"));
const ProfileTickets = lazyWithRetry(() => import("../pages/ProfileTickets"));
const AmbassadorDashboard = lazyWithRetry(() => import("../pages/AmbassadorDashboard"));

const ThanksPage = lazyWithRetry(() => import("../pages/thanks/thanksPage"));
const ThanksDealPage = lazyWithRetry(() => import("../pages/ThanksDealPage"));
const ThanksSpinAndWinPage = lazyWithRetry(() => import("../pages/ThanksSpinAndWin"));

const ArtistProfile = lazyWithRetry(() => import("../pages/ArtistProfile"));
const Inbox = lazyWithRetry(() => import("../pages/Inbox"));
const ConversationDetail = lazyWithRetry(() => import("../pages/ConversationDetail"));
const PromoterDashboard = lazyWithRetry(() => import("../pages/PromoterDashboard"));
const UGCCreatorDashboard = lazyWithRetry(() => import("../pages/UGCCreatorDashboard"));

const HousemateList = lazyWithRetry(() => import("../pages/housemates/HousemateList"));
const HousemateDetail = lazyWithRetry(() => import("../pages/housemates/HousemateDetail"));
const HousemateCreate = lazyWithRetry(() => import("../pages/housemates/HousemateCreate"));
const HousemateApplications = lazyWithRetry(() => import("../pages/housemates/HousemateApplications"));
const MyHousemateListings = lazyWithRetry(() => import("../pages/housemates/MyHousemateListings"));
const MyHousemateApplications = lazyWithRetry(() => import("../pages/housemates/MyHousemateApplications"));
const HousemateProfile = lazyWithRetry(() => import("../pages/housemates/HousemateProfile"));

const JobList = lazyWithRetry(() => import("../pages/jobs/JobList"));
const JobDetail = lazyWithRetry(() => import("../pages/jobs/JobDetail"));
const JobCreate = lazyWithRetry(() => import("../pages/jobs/JobCreate"));
const JobApplications = lazyWithRetry(() => import("../pages/jobs/JobApplications"));
const MyJobListings = lazyWithRetry(() => import("../pages/jobs/MyJobListings"));
const MyJobApplications = lazyWithRetry(() => import("../pages/jobs/MyJobApplications"));

const RestaurantsList = lazyWithRetry(() => import("../pages/restaurants/RestaurantsList"));
const RestaurantDetail = lazyWithRetry(() => import("../pages/restaurants/RestaurantDetail"));
const MyBookings = lazyWithRetry(() => import("../pages/MyBookings"));

const CommunityChats = lazyWithRetry(() => import("../pages/CommunityChats"));
const FamiliesPage = lazyWithRetry(() => import("../pages/FamiliesPage"));
const FamilyDetailPage = lazyWithRetry(() => import("../pages/FamilyDetailPage"));
const FAQ = lazyWithRetry(() => import("../pages/FAQ"));
const Support = lazyWithRetry(() => import("../pages/Support"));

const MyFormsPage = lazyWithRetry(() => import("../pages/MyFormsPage"));
const MyFormResponsesPage = lazyWithRetry(() => import("../pages/MyFormResponsesPage"));
const MyFormEditorPage = lazyWithRetry(() => import("../pages/MyFormEditorPage"));

const CustomPage = lazyWithRetry(() => import("../pages/CustomPage"));

export const AppRoutes = ({
  setLanguage,
  language,
  eventData,
  spinWinEvents,
  eventsLoading,
  setEventsLoading,
  prefetchedTokenFilters,
  deals,
  dealsLoading,
  genres,
  user
}) => [
  <Route key="search" path="search" element={
    <AuthorizedLayout setLanguage={setLanguage} language={language}>
      <SearchResults />
    </AuthorizedLayout>
  } />,
  <Route
    key="events"
    path="events"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <Home
          token={null}
          eventData={eventData}
          spinWinEvents={spinWinEvents}
          genres={genres}
          eventsLoading={eventsLoading}
          setEventsLoading={setEventsLoading}
          language={language}
          setLanguage={setLanguage}
          prefetchedTokenFilters={prefetchedTokenFilters}
        />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="single-event"
    path="single-event"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language} publicAccess>
        <SingleEvent
          token={user.token}
          eventData={eventData}
          language={language}
          setLanguage={setLanguage}
        />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="checkout"
    path="checkout"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <Checkout setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="deal"
    path="deal"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language} publicAccess>
        <DealDetail
          dealData={deals}
          dealsLoading={dealsLoading}
          language={language}
          setLanguage={setLanguage}
        />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="lifestyle"
    path="lifestyle"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <Lifestyle deals={deals} setLanguage={setLanguage} language={language} />
      </AuthorizedLayout>
    }
  />,
  <Route key="deal-requests" path="deal-requests" element={
    <AuthorizedLayout setLanguage={setLanguage} language={language} publicAccess><DealRequests /></AuthorizedLayout>
  } />,
  <Route
    key="spin-and-win"
    path="spin-and-win"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <SpinWinPage
          token={null}
          eventData={eventData}
          spinWinEvents={spinWinEvents}
          genres={genres}
          eventsLoading={eventsLoading}
          setEventsLoading={setEventsLoading}
          language={language}
          setLanguage={setLanguage}
        />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="games"
    path="games"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language} publicAccess>
        <AppOnlyFeature feature="Games" />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="games-lobby"
    path="games/lobby"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language} publicAccess>
        <AppOnlyFeature feature="Games" />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="games-play"
    path="games/play"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <AppOnlyFeature feature="Games" />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="restaurants"
    path="/restaurants"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language} publicAccess>
        <RestaurantsList language={language} setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="restaurant-detail"
    path="/restaurants/:id"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language} publicAccess>
        <RestaurantDetail language={language} setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="my-bookings"
    path="/my-bookings"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <MyBookings />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="profile"
    path="profile"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <Profile language={language} setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="profile-me"
    path="profile/me"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <ProfileInfo language={language} setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="profile-events"
    path="profile/events"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <ProfileTickets language={language} setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="profile-alerts"
    path="profile/alerts"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <ProfileAlerts language={language} setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="profile-prizes"
    path="profile/prizes"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <ProfilePrizes language={language} setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="profile-tickets"
    path="profile/tickets"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <ProfileTickets language={language} setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="profile-ambassador"
    path="profile/ambassador"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <AmbassadorDashboard />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="profile-ugc"
    path="profile/ugc"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <UGCCreatorDashboard />
      </AuthorizedLayout>
    }
  />,
  <Route key="thanksSpin" path="/thanksSpin" element={<ThanksSpinAndWinPage />} />,
  <Route key="thanks" path="/thanks" element={<ThanksPage />} />,
  <Route key="thanksDeal" path="/thanksDeal" element={<ThanksDealPage />} />,
  <Route
    key="artist-profile"
    path="/artist/:slug"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language} publicAccess>
        <ArtistProfile />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="inbox"
    path="/inbox"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <Inbox language={language} setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="inbox-detail"
    path="/inbox/:id"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <ConversationDetail />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="team-member"
    path="/team-member"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <PromoterDashboard />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="housemates"
    path="/housemates"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <HousemateList />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="housemates-create"
    path="/housemates/create"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <HousemateCreate />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="housemates-detail"
    path="/housemates/:id"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <HousemateDetail />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="housemates-edit"
    path="/housemates/:id/edit"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <HousemateCreate />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="housemates-applications"
    path="/housemates/:id/applications"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <HousemateApplications />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="housemates-my-listings"
    path="/housemates/my-listings"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <MyHousemateListings />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="housemates-my-applications"
    path="/housemates/my-applications"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <MyHousemateApplications />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="housemates-profile"
    path="/profile/housemate"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <HousemateProfile />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="jobs"
    path="/jobs"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language} publicAccess>
        <JobList />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="jobs-create"
    path="/jobs/create"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <JobCreate />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="jobs-detail"
    path="/jobs/:id"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language} publicAccess>
        <JobDetail />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="jobs-edit"
    path="/jobs/:id/edit"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <JobCreate />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="jobs-applications"
    path="/jobs/:id/applications"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <JobApplications />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="jobs-my-listings"
    path="/jobs/my-listings"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <MyJobListings />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="jobs-my-applications"
    path="/jobs/my-applications"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <MyJobApplications />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="community-chats"
    path="/community-chats"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <CommunityChats setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="families"
    path="/families"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <FamiliesPage />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="families-detail"
    path="/families/:partnerId"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <FamilyDetailPage />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="faq"
    path="/faq"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <FAQ language={language} setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="support"
    path="/support"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language} publicAccess>
        <Support language={language} setLanguage={setLanguage} />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="my-forms"
    path="/my-forms"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <MyFormsPage />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="my-forms-responses"
    path="/my-forms/:id/responses"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <MyFormResponsesPage />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="my-forms-edit"
    path="/my-forms/:id/edit"
    element={
      <AuthorizedLayout setLanguage={setLanguage} language={language}>
        <MyFormEditorPage />
      </AuthorizedLayout>
    }
  />,
  <Route
    key="custom-page"
    path="page/:slug"
    element={<CustomPage />}
  />
];
